<template>
  <div
    ref="container"
    class="p-l-10 p-r-10 p-t-5 p-b-5"
  >
    <table class="table table_beauty call-log-sub-table-record condensed">
      <thead>
        <tr>
          <th>Name</th>
          <th>Values</th>
        </tr>
        <tr
          v-for="(value, record) in parsedCallRecords"
          :key="record"
        >
          <td>{{ record }}</td>
          <td>
            <TruncatedTextCopy
              :copy-text="value"
            >
              {{ value }}
            </TruncatedTextCopy>
          </td>
        </tr>
      </thead>
    </table>
  </div>
</template>

<script>
import TruncatedTextCopy from '@/angularBridgeCode/components/TruncatedTextCopy';
import callLogDetailMixin from '../mixins/callLogDetailMixin';

function findCol(colDefs, colId) {
  let column;
  
  colDefs.some(columnGroup => {
    column = columnGroup.children.find(column => column.colId === colId);

    return !!column;
  });

  return column;
}

export default {
  name: 'CallRecordsCallLogDetail',
  components: {
    TruncatedTextCopy,
  },

  mixins: [callLogDetailMixin],

  props: {
    callRecord: {
      type: Object,
      default() {
        return {};
      }
    },
    colDefs: {
      type: Array,
      default() {
        return [];
      }
    },
    columnTypes: {
      type: Object,
      default() {
        return {};
      }
    },
  },

  computed: {
    parsedCallRecords() {
      let parsed = {};
      for (const recordProperty in this.callRecord) {
        let columnDef = findCol(this.colDefs, recordProperty);
        let displayRecordProperty = columnDef.headerName;

        if (columnDef?.type && this.columnTypes[columnDef?.type]?.valueFormatter) {
          parsed[displayRecordProperty] = this.columnTypes[columnDef.type].valueFormatter({ value: this.callRecord[recordProperty] });
        } else {
          parsed[displayRecordProperty] = this.callRecord[recordProperty];
        }
      }

      return parsed;
    }
  },

};
</script>

<style lang="scss" scoped>
</style>